export function nowInSeconds() {
  return(Math.floor(Date.now() / 1000));
}
